import React, { useRef, useEffect } from 'react';
import {useLocation, BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import Header from './components/Header';
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ReviewsPage from "./components/ReviewsPage";
import MeetPage from "./components/MeetPage";
import Footer from "./components/Footer";
import './App.css';

function App() {

    const footerRef = useRef(null);

    function HomeStack() {
        const homeRef = useRef(null);
        const aboutRef = useRef(null);
        const reviewsRef = useRef(null);


        const location = useLocation();

        // Map section id strings to refs
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const sectionMap = {
            HomePage: homeRef,
            AboutPage: aboutRef,
            ReviewsPage: reviewsRef,
            Footer: footerRef
        };

        useEffect(() => {
            const scrollTarget = location.state?.scrollTo;
            if (scrollTarget && sectionMap[scrollTarget]?.current) {
                const el = sectionMap[scrollTarget].current;
                const yOffset = -60;
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, [location, sectionMap]);

        return (
            <>
                <div ref={homeRef}>
                    <HomePage/>
                </div>
                <div ref={aboutRef}>
                    <AboutPage/>
                </div>
                <div ref={reviewsRef}>
                    <ReviewsPage/>
                </div>
                <div className={'meetButtonDiv'}>
                    <Link to={'/meet'} className={'meetButton'}>
                        Meet Our Team
                    </Link>
                    <a href={'mailTo:Andrew@williamslawgroup.com'} className={'meetButton'}>Email Andrew</a>
                    <a href={'mailTo:Kevin@williamslawgroup.com'} className={'meetButton'}>Email Kevin</a>
                    {/*<div style={{fontSize: '1.3em'}} className={'meetButton'}>Write A Review!</div>*/}
                </div>
            </>
        );
    }


    return (
        <div className={'App'}>
            <Router>
                <Header/>

                <Routes>
                    <Route path="/" element={<HomeStack/>}/>
                    <Route path="/meet" element={<MeetPage/>}/>
                </Routes>

                <Footer ref={footerRef}/>
            </Router>
        </div>
    );
}

export default App;
